import '../../../styles/components/settings-payement.scss';

import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { env } from '../../../env';

const Payment = () => {
  const [countryValue, setCountryValue] = useState('');
  const [listCountries, setListCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({
    label: null,
    id: null
  });

  const [bankValue, setBankValue] = useState('');
  const [listBanks, setListBanks] = useState([]);

  const [paymentValue, setPaymentValue] = useState(null);
  const [listPayment, setListPayment] = useState([]);

  const getCountries = () => {
    env.http.get('countries').then(data => {
      const response = data.data;
      setListCountries(response);
    });
  };

  const getBanks = () => {
    env.http.get(`banks/${selectedCountry.id}`).then(data => {
      const response = data.data;
      setListBanks(response);
    });
  };

  const getTypePayment = () => {
    env.http.get(`payment-methods/${selectedCountry.id}`).then(data => {
      const response = data.data;
      setListPayment(response);
    });
  };

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(
    () => {
      getBanks();
      getTypePayment();
    },
    [selectedCountry]
  );

  return (
    <div className="settings-payment">
      <h2 className="settings-payment__headline">Страны</h2>

      <div className="settings-payment__wrapper">
        <input
          className="settings-payment__input"
          placeholder="Страны"
          type="text"
          onChange={e => {
            setCountryValue(e.target.value);
          }}
        />

        <button
          className="settings-payment__button"
          value={countryValue}
          onClick={() => {
            env.http
              .post(`countries/`, {
                title: countryValue
              })
              .then(data => {
                getCountries();
              });
          }}
        >
          Добавить
        </button>
      </div>

      {!listCountries.length && (
        <>
          <h3>Поля пустые</h3>
        </>
      )}

      <div className="settings-payment__list">
        {listCountries.map((elem, index) => {
          return (
            <div className="settings-payment-elem" key={elem.id}>
              <div className="settings-payment-elem__text">{elem.title}</div>

              <button
                className="settings-payment__button  settings-payment-elem__button"
                onClick={() => {
                  env.http
                    .delete(`countries/`, {
                      data: {
                        title: elem.title
                      }
                    })
                    .then(data => {
                      getCountries();
                    })
                    .catch(e => {});
                }}
              >
                Удалить
              </button>
            </div>
          );
        })}
      </div>

      <h2 className="settings-payment__headline settings-payment__headline-additional">
        Дополнительная платежная информация
      </h2>

      <Select
        className="settings-payment__select"
        placeholder="Выберете страну"
        value={
          selectedCountry.label && {
            label: selectedCountry.label
          }
        }
        options={listCountries.map(elem => {
          return { id: elem.id, label: elem.title, value: elem.title };
        })}
        onChange={val => {
          setSelectedCountry(val);
        }}
        searchable={false}
      />

      <h2>Метод оплаты</h2>

      <div className="settings-payment__type">
        <Select
          className="settings-payment__select"
          placeholder="Метод оплаты"
          value={
            paymentValue && {
              label: paymentValue
            }
          }
          options={[
            {
              label: 'Банковский перевод',
              value: 'bank'
            },
            {
              label: 'Наличные',
              value: 'wallet'
            },
            {
              label: 'Капиталист',
              value: 'web_money'
            },
            {
              label: 'Western Union',
              value: 'western_union'
            },
            {
              label: 'Crypto',
              value: 'crypto'
            }
          ]}
          type="text"
          onChange={val => {
            setPaymentValue(val.label);
          }}
          searchable={false}
        />

        <button
          className="settings-payment__button"
          onClick={() => {
            env.http
              .post(`payment-methods/${selectedCountry.id}`, {
                title: paymentValue
              })
              .then(data => {
                getTypePayment();
              });
          }}
        >
          Добавить
        </button>
      </div>

      {!listPayment.length && (
        <>
          <h3>Поля пустые</h3>
        </>
      )}
      {listPayment.map((elem, index) => {
        return (
          <div className="settings-payment-elem" key={elem.id}>
            <div className="settings-payment-elem__text">{elem.title}</div>

            <button
              className="settings-payment__button  settings-payment-elem__button"
              onClick={() => {
                env.http
                  .delete(`payment-methods/${elem.country_id}`, {
                    data: {
                      title: elem.title
                    }
                  })
                  .then(data => {
                    getTypePayment();
                  });
              }}
            >
              Удалить
            </button>
          </div>
        );
      })}

      <h2 className="settings-payment__bank-title">Перечень доступных банков</h2>

      <input
        className="settings-payment__input"
        placeholder="Банк"
        type="text"
        value={bankValue}
        onChange={e => {
          setBankValue(e.target.value);
        }}
      />

      <button
        className="settings-payment__button"
        onClick={() => {
          env.http
            .post(`banks/${selectedCountry.id}`, {
              title: bankValue
            })
            .then(data => {
              getBanks();
            });
        }}
      >
        Добавить
      </button>

      {!listBanks.length && (
        <>
          <h3>Поля пустые</h3>
        </>
      )}
      <div className="settings-payment__list">
        {listBanks.map((elem, index) => {
          return (
            <div className="settings-payment-elem" key={elem.id}>
              <div className="settings-payment-elem__text">{elem.title}</div>

              <button
                className="settings-payment__button  settings-payment-elem__button"
                onClick={() => {
                  env.http
                    .delete(`banks/${selectedCountry.id}`, {
                      data: {
                        title: elem.title
                      }
                    })
                    .then(data => {
                      getBanks();
                    });
                }}
              >
                Удалить
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Payment;
